import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import apiurl from "../../services/apiendpoint/apiendpoint";
import { useState } from "react";
import { MultiSelect } from "primereact/multiselect";
import jsPDF from "jspdf";
import { apigetStudyHallFilterOptions } from "../../../../shared/services/apistudyhall/apistudyhall";

export default function Tableview ({tableData, totalRecords, first, rows, loading, setTempFilterValues, tempFilterValues, cusfilter, onPage}) {

     const [filterOptions, setFilterOptions] = useState({});
     const [selectedRow, setSelectedRow] = useState(null);
     const [showModal, setShowModal] = useState(false);
        
        const Sno = (rowIndex) => {
            return (
                <>
                    <div className="flex gap-3">
                        {first+rowIndex+1}
                    </div>
                </>
            );
        };

        const coverimage = (rowData) =>{
            return(
                <>
                <img src={`${apiurl()}/${rowData.Passport_image}`} alt="Profile Image" className="w-14" loading="lazy" />
                </>
            )
        }

        const actionButtons = (rowData) => {
            return (
                <div className="flex gap-2">
                    <button onClick={() => openModal(rowData)} className="px-3 py-1.5 bg-blue-600 text-white rounded text-sm hover:bg-blue-700">
                        View Details
                    </button>
                    <button onClick={() => downloadPDF(rowData)} className="px-3 py-1.5 bg-green-600 text-white rounded text-sm hover:bg-green-700">
                        Download PDF
                    </button>
                </div>
            );
        };

        const openModal = (rowData) => {
            setSelectedRow(rowData);
            setShowModal(true);
        };

        const downloadPDF = async (rowData) => {
            const doc = new jsPDF();
            
            doc.setFontSize(18);
            doc.setFont(undefined, 'bold');
            doc.text('Study Hall Application Details', 105, 20, { align: 'center' });
            
            try {
                const imgUrl = `${apiurl()}/${rowData.Passport_image}`;
                const response = await fetch(imgUrl);
                const blob = await response.blob();
                
                const base64data = await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                });
                
                doc.addImage(base64data, 'JPEG', 150, 10, 40, 40);
            } catch (error) {
                console.error('Error loading image:', error);
            }
            
            doc.setFontSize(14);
            doc.setFont(undefined, 'bold');
            doc.text('Personal Information', 20, 60);
            doc.setFontSize(10);
            doc.setFont(undefined, 'normal');
            
            let yPos = 70;
            const lineHeight = 7;
            
            const personalInfo = [
                ['Name', `${rowData.name} ${rowData.initial}`],
                ['Email', rowData.email],
                ['Mobile Number', rowData.Mobile_number],
                ['Date of Birth', new Date(rowData.dob).toLocaleDateString()],
                ['Gender', rowData.Gender],
                ['Blood Group', rowData.Blood_group],
                ['Specified blood group', rowData.Specified_blood_group || 'N/A'],
                ['Nationality', rowData.Nationality],
                ['Address', rowData.Address],
                ['Pincode', rowData.Pincode]
            ];

            personalInfo.forEach(([label, value]) => {
                doc.setFont(undefined, 'bold');
                doc.text(`${label}:`, 20, yPos);
                doc.setFont(undefined, 'normal');
                doc.text(String(value || 'N/A'), 70, yPos);
                yPos += lineHeight;
            });

            yPos += 5;
            doc.setFontSize(14);
            doc.setFont(undefined, 'bold');
            doc.text('Academic Information', 20, yPos);
            yPos += 10;
            doc.setFontSize(10);
            doc.setFont(undefined, 'normal');

            const academicInfo = [
                ['Qualification', rowData.Qualification],
                ['Special Study', rowData.Special_Study],
                ['Peer Tutoring', rowData.peer_tutoring],
                ['Preferred Study Hours', rowData.preferred_study_hours],
                ['Purpose of Study Hall', rowData.purpose_of_studyhall]
            ];

            academicInfo.forEach(([label, value]) => {
                doc.setFont(undefined, 'bold');
                doc.text(`${label}:`, 20, yPos);
                doc.setFont(undefined, 'normal');
                doc.text(String(value || 'N/A'), 70, yPos);
                yPos += lineHeight;
            });

            yPos += 5;
            doc.setFontSize(14);
            doc.setFont(undefined, 'bold');
            doc.text('Guardian Information', 20, yPos);
            yPos += 10;
            doc.setFontSize(10);
            doc.setFont(undefined, 'normal');

            const guardianInfo = [
                ['Guardian Name', rowData.guardian_name],
                ['Guardian Mobile', rowData.guardian_mobile_number]
            ];

            guardianInfo.forEach(([label, value]) => {
                doc.setFont(undefined, 'bold');
                doc.text(`${label}:`, 20, yPos);
                doc.setFont(undefined, 'normal');
                doc.text(String(value || 'N/A'), 70, yPos);
                yPos += lineHeight;
            });

            yPos += 5;
            doc.setFontSize(14);
            doc.setFont(undefined, 'bold');
            doc.text('Application Status', 20, yPos);
            yPos += 10;
            doc.setFontSize(10);
            doc.setFont(undefined, 'normal');

            const statusInfo = [
                ['Status', rowData.Status],
                ['Created At', new Date(rowData.createdAt).toLocaleString()],
                ['Updated At', new Date(rowData.updatedAt).toLocaleString()]
            ];

            statusInfo.forEach(([label, value]) => {
                doc.setFont(undefined, 'bold');
                doc.text(`${label}:`, 20, yPos);
                doc.setFont(undefined, 'normal');
                doc.text(String(value || 'N/A'), 70, yPos);
                yPos += lineHeight;
            });

            doc.save(`${rowData.name}_${rowData.initial}_Application.pdf`);
        };
    
        const columns = [
            { header: 'S.No', body: Sno },
            { header: 'Profile Image', body: coverimage },
            { field: 'name', header: 'Name', filter: true },
            { field: 'email', header: 'Email', filter: true },
            { field: 'Mobile_number', header: 'Mobile Number', filter: true },
            { field: 'Gender', header: 'Gender', filter: true },
            { field: 'Blood_group', header: 'Blood group', filter: true },
            { field: 'Status', header: 'Status', filter: true },
            { header: 'Actions', body: actionButtons }
        ];
    
        const handleApplyFilters = (key) => {
            cusfilter(key, tempFilterValues[key]);
            onPage({ first: 0, rows: rows });
        };
    
        const handleClearFilters = (key) => {
            setTempFilterValues(prev => ({ ...prev, [key]: null }));
            cusfilter(key, null);
            onPage({ first: 0, rows: rows });
        };
    
        const getOption = async (key)=>{
            var filterOptions = await apigetStudyHallFilterOptions(key);
            setFilterOptions(filterOptions)
            console.log(filterOptions)
        };
    
        const renderColumnFilter = (key) => (
            <div onClick={()=>getOption(key)}>
                <MultiSelect filter value={tempFilterValues[key]} options={filterOptions?.[key]} className="p-column-filter" virtualScrollerOptions={{ itemSize: 43 }} maxSelectedLabels={1}
                    onChange={(e) => setTempFilterValues(prev => ({ ...prev, [key]: e.value }))} placeholder={`Select ${key?.charAt(0).toUpperCase() + key?.slice(1)}`} panelFooterTemplate={
                    <div className="flex justify-between p-2 mt-2">
                        <button label="Clear" onClick={() => handleClearFilters(key)} className="flex items-center text-center justify-center gap-1 px-4 py-2.5 text-sm w-[45%] shadow-sm bg-black text-white cursor-pointer" >
                            Clear
                        </button>
                        <button label="Apply" onClick={() => handleApplyFilters(key)} className="flex items-center text-center justify-center gap-1 px-4 py-2.5 text-sm w-[45%] shadow-sm bg-black text-white cursor-pointer" >
                            Apply
                        </button>
                    </div>
                } />
            </div>
        );

    return (
        <>
         <DataTable value={tableData} loading={loading} totalRecords={totalRecords} scrollable scrollHeight="calc(100vh - 320px)" className="!text-sm border border-gray-200 rounded">
            {columns.map((col, i) => (
                col.header === 'S.No' ?(
                    <Column key={i} field={col.field} header={col.header} body={(rowData,{rowIndex})=>Sno(rowIndex)} headerClassName="text-gray-700 bg-gray-50" />
                ):
                col.header === 'Actions' ? (
                    <Column key={i} header={col.header} body={col.body} headerClassName="text-gray-700 bg-gray-50" style={{ minWidth: '200px' }} />
                ):
                col.formattype === 'array' ? (
                    <Column key={i} header={col.header} field={col.field} style={{ minWidth: col.width }} body={array} filter={col.filter} filterElement={renderColumnFilter(col.field)}
                        showFilterMenuOptions={false} showFilterMatchModes={false} showApplyButton={false} showClearButton={false} sortable headerClassName="text-gray-700 bg-gray-50"/>
                ) : (
                    <Column key={i} field={col.field} header={col.header} body={col.body} filter={col.filter} filterElement={renderColumnFilter(col.field)}
                        showFilterMenuOptions={false} showFilterMatchModes={false} showApplyButton={false} showClearButton={false} sortable headerClassName="text-gray-700 bg-gray-50" />
                )
            ))}
        </DataTable>

        <Dialog visible={showModal} onHide={() => setShowModal(false)} header="Application Details" style={{ width: '50vw' }}breakpoints={{ '960px': '75vw', '641px': '90vw' }}>
            {selectedRow && (
                <div className="space-y-6">
                    <div className="flex justify-center">
                        <img src={`${apiurl()}/${selectedRow.Passport_image}`} alt="Profile" className="object-cover w-32 h-32 border-2 border-gray-200 rounded-lg"/>
                    </div>

                    <div>
                        <h3 className="pb-2 mb-3 text-lg font-semibold text-gray-800 border-b">Personal Information</h3>
                        <div className="grid grid-cols-2 gap-3 text-sm">
                            <div><span className="font-semibold">Name:</span> {selectedRow.name} {selectedRow.initial}</div>
                            <div><span className="font-semibold">Email:</span> {selectedRow.email}</div>
                            <div><span className="font-semibold">Mobile:</span> {selectedRow.Mobile_number}</div>
                            <div><span className="font-semibold">DOB:</span> {new Date(selectedRow.dob).toLocaleDateString()}</div>
                            <div><span className="font-semibold">Gender:</span> {selectedRow.Gender}</div>
                            <div><span className="font-semibold">Blood Group:</span> {selectedRow.Blood_group}</div>
                            <div><span className="font-semibold">Nationality:</span> {selectedRow.Nationality}</div>
                            <div className="col-span-2"><span className="font-semibold">Address:</span> {selectedRow.Address}</div>
                            <div><span className="font-semibold">Pincode:</span> {selectedRow.Pincode}</div>
                        </div>
                    </div>

                    <div>
                        <h3 className="pb-2 mb-3 text-lg font-semibold text-gray-800 border-b">Academic Information</h3>
                        <div className="grid grid-cols-2 gap-3 text-sm">
                            <div><span className="font-semibold">Qualification:</span> {selectedRow.Qualification}</div>
                            <div><span className="font-semibold">Special Study:</span> {selectedRow.Special_Study}</div>
                            <div><span className="font-semibold">Peer Tutoring:</span> {selectedRow.peer_tutoring}</div>
                            <div><span className="font-semibold">Preferred Study Hours:</span> {selectedRow.preferred_study_hours}</div>
                            <div className="col-span-2"><span className="font-semibold">Purpose:</span> {selectedRow.purpose_of_studyhall}</div>
                        </div>
                    </div>

                    <div>
                        <h3 className="pb-2 mb-3 text-lg font-semibold text-gray-800 border-b">Guardian Information</h3>
                        <div className="grid grid-cols-2 gap-3 text-sm">
                            <div><span className="font-semibold">Guardian Name:</span> {selectedRow.guardian_name}</div>
                            <div><span className="font-semibold">Guardian Mobile:</span> {selectedRow.guardian_mobile_number}</div>
                        </div>
                    </div>

                    <div>
                        <h3 className="pb-2 mb-3 text-lg font-semibold text-gray-800 border-b">Documents</h3>
                        <div className="space-y-2 text-sm">
                            <div><a href={`${apiurl()}/${selectedRow.Address_proof}`} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">📄 Address Proof</a></div>
                            <div><a href={`${apiurl()}/${selectedRow.Id_proof}`} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">📄 ID Proof</a></div>
                            <div><a href={`${apiurl()}/${selectedRow.Aadhar}`} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">📄 Aadhar</a></div>
                        </div>
                    </div>

                    <div>
                        <h3 className="pb-2 mb-3 text-lg font-semibold text-gray-800 border-b">Status Information</h3>
                        <div className="grid grid-cols-2 gap-3 text-sm">
                            <div><span className="font-semibold">Status:</span> <span className={`px-2 py-1 rounded ${selectedRow.Status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>{selectedRow.Status}</span></div>
                            <div><span className="font-semibold">Created:</span> {new Date(selectedRow.createdAt).toLocaleString()}</div>
                            <div className="col-span-2"><span className="font-semibold">Updated:</span> {new Date(selectedRow.updatedAt).toLocaleString()}</div>
                        </div>
                    </div>

                    <div className="flex justify-end pt-4 border-t">
                        <button onClick={() => downloadPDF(selectedRow)} className="px-4 py-2 text-white bg-green-600 rounded hover:bg-green-700">
                            Download as PDF
                        </button>
                    </div>
                </div>
            )}
        </Dialog>
        </>
    )
}